import React, { useState, useEffect } from 'react'
import {
  FormControl,
  InputBase,
  InputLabel,
  FormHelperText,
  Collapse,
} from '@mui/material'
import { useField } from 'formik'

export default ({ id, name, label, className = '', sx={}, ...props }) => {
  const [field, meta] = useField(name)
  const [lastError, setLastError] = useState(meta.error)

  useEffect(() => {
    if (meta.error) setLastError(meta.error)
  }, [meta.error])

  return (
    <FormControl
      variant='standard'
      error={Boolean(meta.touched && meta.error)}
      className={className}
      sx={sx}
    >
      <InputLabel shrink htmlFor={id}>
        {label}
      </InputLabel>
      <InputBase id={id} {...field} {...props} />
      <Collapse in={Boolean(meta.touched && meta.error)} timeout={200}>
        <FormHelperText error>{lastError}</FormHelperText>
      </Collapse>
    </FormControl>
  )
}